import { Theme, alpha } from '@mui/material/styles';
import { CSSProperties } from '@mui/material/styles/createMixins';

export const getNeedHelpButtonStyles = (theme: Theme): CSSProperties => ({
  borderColor:
    theme.palette.mode === 'light'
      ? theme.blox.colors.lightgray
      : theme.blox.colors.white,
  width: '100%',
  display: 'flex',
  textAlign: 'left',
  px: 2,
  justifyContent: 'space-between',
  '.MuiSvgIcon-root': {
    fill: theme.blox.colors.gray2,
  },
  '.MuiButton-startIcon': {
    backgroundColor: alpha(theme.blox.colors.logoblue, 0.1),
    borderRadius: '50%',
    p: 1,
  },
  '.help-button-title': {
    color:
      theme.palette.mode === 'light'
        ? theme.blox.colors.offblack
        : theme.blox.colors.white,
  },
  '.help-button-subtitle': {
    fontWeight: 400,
    color:
      theme.palette.mode === 'light' ? theme.blox.colors.gray2 : theme.blox.colors.white,
  },
});

export const getLinksWrapperStyles = (theme: Theme): CSSProperties => ({
  backgroundColor: theme.palette.mode === 'light' ? theme.blox.colors.gray5 : '',
  p: 2,
  borderRadius: '4px',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  gap: '8px',
});
